<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large"
    title="確認"
  >
    <template v-slot:body="{ ok, cancel }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <v-row class="pb-3">
              <strong>
                {{ confirmMessage }}
                <!-- 注意文言：品目をGbpsからGbpsへ変更した場合のみ表示する -->
                <template v-if="isGbpsChange">
                  <br />帯域変更は1日1回のみ可能です。設定内容について再度ご確認ください。
                </template>
              </strong>
            </v-row>

            <div class="my-3">
              <!-- クラウド設定 -->
              <v-row>
                <v-col>
                  <h3>クラウド設定</h3>
                </v-col>
              </v-row>
              <!--OCID(Act)-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="OCID(Act)"
                    :value="cloudVnOracleDetail.cloudVnConnectAct.serviceKey"
                  />
                </v-col>
              </v-row>
              <!--OCID(Sby)-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="OCID(Sby)"
                    :value="
                      cloudVnOracleDetail.cloudVnConnectSby
                        ? cloudVnOracleDetail.cloudVnConnectSby.serviceKey
                        : '-'
                    "
                  />
                </v-col>
              </v-row>
              <!--ロケーション-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="ロケーション"
                    :value="
                      $filter.enumTo(
                        cloudVnOracleDetail.cloudVnConnectCommon.location,
                        'location'
                      )
                    "
                  />
                </v-col>
              </v-row>
              <!--接続先仮想ネットワーク（VPN/VN）名-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="接続先仮想ネットワーク(VPN/VN)名"
                    :value="
                      cloudVnOracleDetail.cloudVnConnectCommon.vpnVnCode.startsWith(
                        'B'
                      )
                        ? cloudVnOracleDetail.cloudVnConnectCommon.vpnVnCode
                        : cloudVnOracleDetail.cloudVnConnectCommon.vnName +
                          ':' +
                          cloudVnOracleDetail.cloudVnConnectCommon.vpnVnCode +
                          '(L3)'
                    "
                  />
                </v-col>
              </v-row>

              <!-- VNコネクト設定 -->
              <v-row class="mt-2">
                <v-col>
                  <h3>VNコネクト設定</h3>
                </v-col>
              </v-row>
              <!--品目-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="品目"
                    :value="
                      cloudVnOracleDetail.cloudVnConnectCommon.bandwidthType +
                      '(' +
                      $filter.bandwidthTo(
                        cloudVnOracleDetail.cloudVnConnectCommon.bandwidth
                      ) +
                      ')'
                    "
                  />
                </v-col>
              </v-row>
              <!--VNコネクト名（Act）-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="VNコネクト名(Act)"
                    :value="cloudVnOracleDetail.cloudVnConnectAct.vnConnectName"
                  />
                </v-col>
              </v-row>
              <!--VNコネクト名（Sby）-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="VNコネクト名(Sby)"
                    :value="
                      cloudVnOracleDetail.cloudVnConnectSby
                        ? cloudVnOracleDetail.cloudVnConnectSby.vnConnectName
                        : '-'
                    "
                  />
                </v-col>
              </v-row>

              <!-- ルーティング情報（共通） -->
              <v-row class="mt-2">
                <v-col>
                  <h3>ルーティング情報(共通)</h3>
                </v-col>
              </v-row>
              <!--ルーティング種別-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="ルーティング種別"
                    :value="
                      cloudVnOracleDetail.cloudVnConnectCommon.routingType
                    "
                  />
                </v-col>
              </v-row>
              <!--AS番号-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="AS番号"
                    :value="cloudVnOracleDetail.cloudVnConnectAct.asNumber"
                  />
                </v-col>
              </v-row>
              <!--Maximum Prefix-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="Maximum Prefix"
                    :value="
                      $filter.emptyTo(
                        cloudVnOracleDetail.cloudVnConnectAct.maximumPrefix,
                        '-'
                      )
                    "
                  />
                </v-col>
              </v-row>

              <!-- ルーティング情報（Act） -->
              <v-row class="mt-2">
                <v-col>
                  <h3>ルーティング情報(Act)</h3>
                </v-col>
              </v-row>
              <!--WANアドレス（Act）-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="WANアドレス"
                    :value="
                      $filter.emptyTo(
                        cloudVnOracleDetail.cloudVnConnectAct.wanAddress,
                        '-'
                      )
                    "
                  />
                </v-col>
              </v-row>
              <!--ピアIPアドレス（Act）-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="ピアIPアドレス"
                    :value="
                      $filter.emptyTo(
                        cloudVnOracleDetail.cloudVnConnectAct.peerIpAddress,
                        '-'
                      )
                    "
                  />
                </v-col>
              </v-row>
              <!--Local Preference（Act）-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="Local Preference"
                    :value="
                      $filter.enumTo(
                        cloudVnOracleDetail.cloudVnConnectAct.localPreference,
                        'localPreference'
                      )
                    "
                  />
                </v-col>
              </v-row>
              <!--MED（Act）-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="MED"
                    :value="
                      $filter.enumTo(
                        cloudVnOracleDetail.cloudVnConnectAct.med,
                        'med'
                      )
                    "
                  />
                </v-col>
              </v-row>

              <!-- ルーティング情報（Sby） -->
              <v-row class="mt-2">
                <v-col>
                  <h3>ルーティング情報(Sby)</h3>
                </v-col>
              </v-row>
              <template v-if="cloudVnOracleDetail.cloudVnConnectSby">
                <!--WANアドレス（Sby）-->
                <v-row>
                  <v-col>
                    <app-label-group
                      label="WANアドレス"
                      :value="
                        $filter.emptyTo(
                          cloudVnOracleDetail.cloudVnConnectSby.wanAddress,
                          '-'
                        )
                      "
                    />
                  </v-col>
                </v-row>
                <!--ピアIPアドレス（Sby）-->
                <v-row>
                  <v-col>
                    <app-label-group
                      label="ピアIPアドレス"
                      :value="
                        $filter.emptyTo(
                          cloudVnOracleDetail.cloudVnConnectSby.peerIpAddress,
                          '-'
                        )
                      "
                    />
                  </v-col>
                </v-row>
                <!--Local Preference（Sby）-->
                <v-row>
                  <v-col>
                    <app-label-group
                      label="Local Preference"
                      :value="
                        $filter.enumTo(
                          cloudVnOracleDetail.cloudVnConnectSby.localPreference,
                          'localPreference'
                        )
                      "
                    />
                  </v-col>
                </v-row>
                <!--MED（Sby）-->
                <v-row>
                  <v-col>
                    <app-label-group
                      label="MED"
                      :value="
                        $filter.enumTo(
                          cloudVnOracleDetail.cloudVnConnectSby.med,
                          'med'
                        )
                      "
                    />
                  </v-col>
                </v-row>
              </template>
              <div class="ml-3 mb-3" v-else><span>-</span></div>

              <template
                v-if="cloudVnOracleDetail.cloudVnConnectCommon.routeAggregation"
              >
                <!-- カスタム経路集約情報 -->
                <v-row class="mt-2">
                  <v-col>
                    <h3>カスタム経路集約情報</h3>
                  </v-col>
                </v-row>
                <!--経路集約-->
                <v-row>
                  <v-col>
                    <app-label-group
                      label="経路集約"
                      :value="
                        cloudVnOracleDetail.cloudVnConnectCommon
                          .routeAggregation
                      "
                    />
                  </v-col>
                </v-row>

                <!--注意文言 : 追加確認画面又は変更確認画面のみ表示-->
                <template
                  v-if="
                    cloudVnOracleDetail.cloudVnConnectCommon
                      .routeAggregation === 'OFF'
                  "
                >
                  <v-row v-if="displayType === 'A' || displayType === 'M'">
                    <v-col>
                      <app-label-group
                        label="WVS2で学習している経路をすべて広報いたします。クラウド側の受信経路上限数を超過している場合は接続ができません。"
                      />
                    </v-col>
                  </v-row>
                </template>

                <!--経路集約アドレス-->
                <v-row v-else>
                  <v-col>
                    <app-label-group label="経路集約アドレス">
                      <template #value>
                        <template
                          v-if="
                            cloudVnOracleDetail.cloudVnConnectCommon
                              .routeAggregation === 'CUSTOM'
                          "
                        >
                          <div class="d-flex flex-wrap">
                            <span
                              class="ml-3"
                              v-for="(
                                ip, index
                              ) in sortedRouteAggregationAddressList"
                              :key="index"
                            >
                              {{ ip }}
                            </span>
                          </div>
                        </template>
                        <template
                          v-else-if="
                            cloudVnOracleDetail.cloudVnConnectCommon
                              .routeAggregation === 'ON'
                          "
                        >
                          <span class="ml-3">0.0.0.0/0</span>
                        </template>
                      </template>
                    </app-label-group>
                  </v-col>
                </v-row>
              </template>

              <!--備考-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="備考"
                    :value="
                      $filter.emptyTo(
                        cloudVnOracleDetail.cloudVnConnectCommon.description,
                        '-'
                      )
                    "
                  />
                </v-col>
              </v-row>

              <template v-if="displayType === 'A'">
                <div class="font-weight-bold mt-5">
                  VNコネクトを追加する前に、以下確認をしてください。
                </div>
                <v-sheet border rounded class="pa-2">
                  <template
                    v-for="(notice, index) in noticeOptions"
                    :key="`${notice.text + index}`"
                  >
                    <v-checkbox
                      v-model="checkedItems"
                      :value="notice.value"
                      :label="notice.text"
                      hide-details
                      class="multiline-checkbox"
                    />
                  </template>
                </v-sheet>
              </template>
            </div>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn
              @click="ok"
              variant="flat"
              color="primary"
              :disabled="
                displayType === 'A' && noticeOptions.length > 0
                  ? !(checkedItems.length === noticeOptions.length)
                  : false
              "
              >はい</v-btn
            >
            <v-btn @click="cancel" variant="outlined" color="primary"
              >いいえ</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { CloudVnOracleDetail } from "@/apis/CloudVnOracleApi";
import type { BandWidth } from "@/apis/CloudVnMsApi";

export default defineComponent({
  name: "MultiCloudOracleVnConnectionConfirm",
  props: {
    cloudVnOracleDetail: {
      type: Object as PropType<CloudVnOracleDetail>,
      required: true,
    },
    // 品目をGbpsからGbpsへ変更した場合に注意文言を表示するため、変更前の品目の値を取得
    beforeBandWidth: {
      type: Object as PropType<BandWidth>,
    },
    /** 画面表示モード：
     * A - 追加確認
     * M - 編集確認
     * D - 削除確認
     */
    displayType: {
      type: String as PropType<"A" | "M" | "D">,
      required: true,
    },
  },
  computed: {
    confirmMessage(): string {
      switch (this.displayType) {
        case "A":
          return "こちらの内容でクラウド接続向けVN回線を追加します。よろしいですか？";
        case "M":
          return "こちらの内容でクラウド接続向けVN回線を変更します。よろしいですか？";
        case "D":
          return "こちらの内容でクラウド接続向けVN回線を削除します。よろしいですか？";
        default:
          throw new Error("wrong displayType!");
      }
    },
    isGbpsChange(): boolean {
      // 追加/削除/Sbyのみ追加時は、チェック不要で非表示
      if (!this.beforeBandWidth) return false;

      const bandwidthRangeBig = [
        { value: 2, unit: "GBPS" },
        { value: 3, unit: "GBPS" },
        { value: 4, unit: "GBPS" },
        { value: 5, unit: "GBPS" },
        { value: 6, unit: "GBPS" },
        { value: 7, unit: "GBPS" },
        { value: 8, unit: "GBPS" },
        { value: 9, unit: "GBPS" },
        { value: 10, unit: "GBPS" },
      ];
      // 変更前の帯域が2GB以上のレンジか否か
      const before = bandwidthRangeBig.some(
        (e) =>
          e.value === this.beforeBandWidth!.value &&
          e.unit === this.beforeBandWidth!.unit
      );
      // 変更後の帯域が2GB以上のレンジか否か
      const after = bandwidthRangeBig.some(
        (e) =>
          e.value ===
            this.cloudVnOracleDetail.cloudVnConnectCommon.bandwidth.value &&
          e.unit ===
            this.cloudVnOracleDetail.cloudVnConnectCommon.bandwidth.unit
      );
      // レンジが異なる場合のみ警告表示
      return before !== after;
    },
    noticeOptions(): { text: string; value: string }[] {
      return [
        {
          text: "一度使用したことのあるOCIDを入力していないこと",
          value: "CHECKED_OCID",
        },
        {
          text: "VNコネクト作成中はOracle Cloudの設定変更は実施しないこと",
          value: "CHECKED_NOT_CHANGE",
        },
      ];
    },
    /**
     * 経路集約アドレスリストを数値順（IPアドレス順）で昇順ソートして返す
     * 削除確認画面（displayType === "D"）の場合のみソートを適用
     * @returns ソート済みの経路集約アドレスリスト
     */
    sortedRouteAggregationAddressList(): string[] {
      const list =
        this.cloudVnOracleDetail?.cloudVnConnectCommon
          ?.routeAggregationAddressList;
      if (this.displayType === "D" && Array.isArray(list)) {
        return list.sortIpAddress();
      }
      return Array.isArray(list) ? list : [];
    },
  },
  data() {
    return {
      checkedItems: [],
    };
  },
});
</script>

<style lang="scss" scoped>
:deep(.multiline-checkbox .v-label) {
  white-space: pre-line;
}
:deep(.v-checkbox .v-selection-control) {
  min-height: auto;
}
</style>
